module.exports = __webpack_public_path__ + "static/media/meta.5aa66c8e.jpg";